<template>
  <div class="page-inner">
    <KakaoButton
      @kakaoSignUp="kakaoSignUp"
      @kakaoSignIn="kakaoSignIn"
    />
    <v-btn color="primary" x-large outlined block rounded @click="gotoSignIn">
      회원가입
    </v-btn>
  </div>
</template>
<script>
import KakaoButton from "@/_bayer/kakaoCommon/KakaoButton.vue";
export default {
  components: { KakaoButton },
  methods: {
    gotoSignIn() {
      this.$router.push({ path: "/signup" }).catch(() => {});
    },
    kakaoSignUp(e) {
      this.$emit("kakaoSignUp", e);
    },
    kakaoSignIn(e) {
      this.$emit("kakaoSignIn", e);
    },
  },
};
</script>